import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DoubleChevronLeft, DoubleChevronRight } from "@air/next-icons";
export const VideoPlaybackSpeedAlert = (param)=>{
    let { playbackSpeed } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "pointer-events-none absolute left-1/2 top-1/2 z-30 flex size-20 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-grey-1 text-white shadow-popover",
        children: [
            playbackSpeed < 0 ? /*#__PURE__*/ _jsx(DoubleChevronLeft, {
                className: "size-8"
            }) : /*#__PURE__*/ _jsx(DoubleChevronRight, {
                className: "size-8"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-12 font-semibold",
                children: [
                    Math.abs(playbackSpeed),
                    "x"
                ]
            })
        ]
    });
};
